import { createFileRoute, redirect } from '@tanstack/react-router'
import { AppShell } from '@/components/app-shell'
import { type DateRange, meQuery, parseDateRange } from '@/lib/queries'

export const Route = createFileRoute('/_app')({
  // The window is validated here rather than on each report because the control
  // that sets it is in the shell, above all of them: a param only some routes
  // accept is a control that goes dead — or silently drops what it was holding
  // — the moment you open a page that does not read one. Reports read it,
  // backlinks and settings ignore it, and it survives either way.
  validateSearch: (search: Record<string, unknown>): { range?: DateRange } => {
    const range = parseDateRange(search.range)
    return range ? { range } : {}
  },
  // Everything inside this layout requires a session and a workspace. Loading
  // it here means child routes can assume both exist.
  beforeLoad: async ({ context, location }) => {
    try {
      await context.queryClient.ensureQueryData(meQuery)
    } catch {
      throw redirect({ to: '/login', search: { redirect: location.href } })
    }
  },
  component: AppShell,
})
